import React from "react";
import { differenceInSeconds, formatDistanceToNow } from "date-fns";
import {
  TimeIconStyled,
  RefreshIconStyled,
  LastUpdatedWrapper,
  LastUpdatedText,
  RefreshLink,
} from "./styles";

export interface LastUpdatedHeaderProps {
  lastUpdated: string | Date | null;
  onRefresh: () => void;
}

export const LastUpdatedHeader: React.FC<LastUpdatedHeaderProps> = ({
  lastUpdated,
  onRefresh,
}) => {
  const [now, setNow] = React.useState<Date>(new Date());

  React.useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 5000);
    return () => clearInterval(interval);
  }, [lastUpdated]);

  const lastUpdateDate =
    typeof lastUpdated === "string" ? new Date(lastUpdated) : lastUpdated;
  const lastUpdateDisplay = lastUpdateDate
    ? differenceInSeconds(now, lastUpdateDate) < 5
      ? "now"
      : formatDistanceToNow(lastUpdateDate, {
          addSuffix: true,
          includeSeconds: true,
        })
    : "Never";

  return (
    <LastUpdatedWrapper>
      {lastUpdated ? (
        <LastUpdatedText>
          <TimeIconStyled />
          Last updated: {lastUpdateDisplay}
        </LastUpdatedText>
      ) : null}
      <RefreshLink onClick={onRefresh}>
        <RefreshIconStyled />
        Refresh
      </RefreshLink>
    </LastUpdatedWrapper>
  );
};
